import { FC, useMemo } from 'react';

import { FieldComponentProps } from '@app/components/common/types';
import { SelectField } from '@app/components/common';

export const CorrAccountField: FC<FieldComponentProps<string> & { options: EntityBase[] }> = ({ value, onChange, options, ...props }) => { 

  const selectedItem = useMemo(() => {
    if (!value) {return undefined;}
    return options.find(({ name }) => name === value);
  }, [value, options]);


  return <SelectField 
    id='deferment_field'  
    value={selectedItem}
    onChangeValue={onChange}
    options={options}
    {...props}
  />;
}; 